import {InsightsApi} from "../api/InsightsApi";
import {CapitalMarketAssumption, ICapitalMarketAssumption} from "../model/thought-leadership/CapitalMarketAssumption";
import {IMediumTermView, MediumTermView} from "../model/thought-leadership/MediumTermView.model";
import {
    IMarketOutlookDocument, MarketOutlookDocument,
} from "../model/thought-leadership/MarketOutlookDocument.model";
import {UserBehaviorTrackerApi} from "../api/UserBehaviorTrackerApi";
import {getBrowserLocationPath} from "../api/BrowserWrapper";

export type MarketOutlook = ICapitalMarketAssumption | IMediumTermView | IMarketOutlookDocument;

export const ALL_YEARS = "All Years";
export const ALL_TYPES = "All Document Types";

export enum DocumentType {
    CMA = "Capital Market Assumptions",
    MTV = "Medium Term Views",
    QIO = "Quarterly Investment Outlook",
    MB = "Market Background"
}

export function getDocumentType(document: MarketOutlook) {
    if (document instanceof CapitalMarketAssumption) {
        return (document as CapitalMarketAssumption).transform().type;
    } else if (document instanceof MediumTermView) {
        return (document as MediumTermView).transform().type;
    } else {
        return (document as MarketOutlookDocument).transform().type;
    }
}

export function download(document: MarketOutlook) {
    UserBehaviorTrackerApi.trackUserBehavior(getBrowserLocationPath() + "/" + document.title);
    InsightsApi.getDocumentDownload(document.backstopId, document.fileName, true);
}

export const documentTypeEnumValueFromKey = (type: string): DocumentType => {
    return DocumentType[type as keyof typeof DocumentType];
};

export const documentTypeEnumKeyFromValue = (type: DocumentType): string => {
    return Object.keys(DocumentType).find(key => DocumentType[key as keyof typeof DocumentType] === type)!;
};
